import MotionWrapper from '../../../../containers/MotionWrapper';
import Button from '../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

export default function UseSignInForm() {
    const navigate = useNavigate();

    const navigateToSignIn = () => {
        navigate('/signin')
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <span className={styles.title}>
                Your email is verified successfully <br />
                Please use our sign in form to access your dashboard.
            </span>
            <Button
                type='Primary'
                text='Navigate to sign in'
                onClick={navigateToSignIn}
            />
        </MotionWrapper>
    )
};
